import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { ArrowLeft } from "heroicons-react";

import LoginForm from "../components/auth/LoginForm";
import ResetPasswordForm from "../components/auth/ResetPasswordForm";
import ForgotPasswordForm from "../components/auth/ForgotPasswordForm";

export default function Login() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const resetToken = searchParams.get("token");
  const [isForgotMode, setIsForgotMode] = useState(false);

  return (
    <div className="flex flex-col lg:flex-row min-h-screen lg:h-screen lg:overflow-hidden">
      {/* Left Image Banner */}
      <div className="hidden lg:flex w-1/2 h-full">
        <img
          src="./images/loginpic.jpg"
          className="object-cover w-full h-full"
          alt="sideimage"
        />
      </div>

      {/* Right Content Section */}
      <div className="w-full lg:w-1/2 px-6 sm:px-12 py-3 sm:py-4 flex flex-col justify-between h-full overflow-y-auto">
        {/* Top bar with Back button and LanguageSwitcher */}
        <div className="w-full flex items-center justify-between pb-1 shrink-0">
          <Link
            to="/"
            className="text-[#037897] font-gilroy-medium text-sm flex items-center hover:opacity-80 transition-opacity"
          >
            <ArrowLeft className="w-4 inline-block mr-2" /> {t("login.backHome", "Back to Home")}
          </Link>
          <LanguageSwitcher isMobile={true} />
        </div>

        {/* Main form container */}
        <div className="w-full max-w-2xl mx-auto my-auto py-4">
          {resetToken ? (
            <ResetPasswordForm token={resetToken} />
          ) : isForgotMode ? (
            <ForgotPasswordForm onCancel={() => setIsForgotMode(false)} />
          ) : (
            <LoginForm onForgotPassword={() => setIsForgotMode(true)} />
          )}
        </div>
      </div>
    </div>
  );
}